import api from '../API';

// Create Stripe instance at runtime.
// Buildtime configuration does not allow 1 Docker image
// to support multiple environments.
let stripe:any;
function getStripe() {
  if (!stripe) {
    // @ts-ignore
    stripe = Stripe(window.env.STRIPE_KEY);
  }
  return stripe;
}

let elements:any;
function getElements() {
  if (!elements) {
    elements = getStripe().elements();
  }
  return elements;
}


const style = {
  base: {
    fontFamily: '"Roboto", "-apple-system", "Helvetica Neue", Helvetica, Arial, sans-serif',
    fontSize: '14px',
    '::placeholder': {
      fontSize: '16px',
    },
  },
};

export function createElement(type: string, placeholder: string) {
  return getElements().create(type, { style, placeholder });
}

function createClientSecret() {
  return api
    .post('payments/setup-intents')
    // @ts-ignore
    .then(response => response.data.clientKey);
}

function handleCardSetupResult(result: any) {
  if (result.error) {
    return Promise.reject(result.error);
  }
  return result.setupIntent.payment_method;
}

function confirmCardSetup(
  clientSecret: string,
  nameOnCard: string,
  cardNoElement: object,
): Promise<string> {
  return getStripe()
    .confirmCardSetup(
      clientSecret,
      {
        payment_method: {
          card: cardNoElement,
          billing_details: {
            name: nameOnCard,
          },
        },
      },
    )
    .then(handleCardSetupResult);
}

export function createPaymentMethod(nameOnCard: string, cardNoElement: object): Promise<string> {
  return createClientSecret()
    .then(clientSecret => confirmCardSetup(clientSecret, nameOnCard, cardNoElement));
}
